<template>
  <div class="daily">
    <div class="head">
      <img class="logo" src="@/assets/logo.png">
      <div class="title">{{date}}</div>
    </div>
    <div class="playlist">
      <div
        class="playlist__item"
        v-for="({id, songName, singerName, message, likeCount}, index) in playList"
        :key="id"
      >
        <div class="song">
          <div class="song-name">{{songName}}</div>
          <div class="singer-name">{{singerName}}</div>
          <div v-if="message" class="message">{{message}}</div>
        </div>
        <div class="comment"></div>
        <div
          class="like"
          :class="isLike[index]"
          @click="onLikeClick(index, isLike[index])"
        >{{likeCount}}</div>
      </div>
      <!-- <div class="playlist__item">
        <div class="song-name">告白气球</div>
        <div class="singer-name">周杰伦</div>
        <div class="message">慢慢喜欢你</div>
        <div class="comment">1314 评论</div>
        <div class="like">520 like</div>
      </div> -->
    </div>

    <copyright></copyright>
  </div>
</template>

<script>
// import { CellGroup } from 'vant'
import Copyright from '@/components/Copyright'
import api from '@/api'
import dayjs from 'dayjs'

export default {
  name: 'Daily',
  components: {
    'copyright': Copyright,
  },
  data () {
    return {
      playList: [],
      isLike: ['', '', '']
    }
  },
  computed: {
    date() {
      const { date } = this.$route.query
      return dayjs(date).format('YYYY/M/D').toString()
    }
  },
  methods: {
    async getList(date) {
      const res = await api.getDailyList(date)
      console.log(res)
      if (res.code === 0) {
        this.playList = res.data.list
      } else {
        this.$toast(res.message)
      }
    },
    async onLikeClick(index, cancel) {
      let item = this.playList[index]
      let { id, likeCount } = item
      const res = await api.likeTheOrder({
        id,
        cancel
      })
      if (res.code === 0) {
        this.playList[index].likeCount = cancel ? likeCount - 1 : likeCount + 1
        // item.likeCount = cancel ? likeCount - 1 : likeCount + 1
        // this.$set(this.playList, index, item)
        this.$set(this.isLike, index, cancel ? '' : 'active')
      } else {
        this.$toast(res.message)
      }
    },
  },
  created () {
    const { date } = this.$route.query
    this.getList(date)
  }
}
</script>

<style lang="less" scoped>
@icon-like: '../../assets/like.png';
@icon-like-fill: '../../assets/like_fill.png';

.daily {
  display: flex;
  flex-direction: column;
  height: 100vh;
}
.head {
  display: flex;
  height: 60px;
  padding: 20px;
  .logo {
    height: 20px;
  }
  .title {
    margin-left: 20px;
    font-size: 20px;
    font-weight: bold;
    line-height: 1;
  }
}
.date {
  flex-shrink: 0;
  height: 60px;
  padding: 20px;
  font-size: 20px;
  font-weight: bold;
  line-height: 1;
  // color: #666;
}
.playlist {
  flex: 1;
  display: flex;
  flex-direction: column;
  &__item {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    border-top: 1px solid #f1f1f1;
    padding: 20px;
    line-height: 1;
    position: relative;
    .song {
      min-height: 60px;
    }
    .song-name {
      font-size: 20px;
      font-weight: bold;
      color: #000;
    }
    .singer-name {
      margin-top: 8px;
      font-size: 14px;
      color: #999;
    }
    .message {
      flex: 1;
      margin-top: 10px;
      // padding: 0 10px;
      font-size: 14px;
      line-height: 20px;
      position: relative;
      &:before {
        content: '“ ';
        font-size: 20px;
        font-weight: bold;
        color: #999;
      }
      &:after {
        content: ' ”';
        font-size: 20px;
        font-weight: bold;
        color: #999;
      }
    }
    .ft {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
    }
    .comment {
      font-size: 14px;
      color: #000;
    }
    .like {
      display: flex;
      position: absolute;
      top: 20px;
      right: 20px;
      font-size: 14px;
      line-height: 20px;
      color: #999;
      cursor: pointer;
      &:before {
        content: '';
        margin-right: 2px;
        display: block;
        width: 18px;
        height: 18px;
        background: url(@icon-like) 0 0 no-repeat;
        background-size: contain;
      }
      &.active {
        &:before {
          background-image: url(@icon-like-fill);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/daily/index.vue